/** @jsxImportSource react */
import React, { ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  onClick?: () => void
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  onClick,
}) => {
  return (
    <div
      className={`bg-white rounded-xl border border-slate-200/70 shadow-sm hover:shadow-md transition-all duration-300 ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export const CardHeader: React.FC<{
  children: ReactNode
  className?: string
}> = ({ children, className = '' }) => {
  return (
    <div
      className={`p-6 border-b border-slate-100 bg-gradient-to-r from-white to-slate-50/50 ${className}`}
    >
      {children}
    </div>
  )
}

export const CardContent = React.forwardRef<
  HTMLDivElement,
  { children: ReactNode; className?: string }
>(({ children, className = '' }, ref) => {
  return (
    <div ref={ref} className={`p-6 ${className}`}>
      {children}
    </div>
  )
})
CardContent.displayName = 'CardContent'

export const CardFooter: React.FC<{
  children: ReactNode
  className?: string
}> = ({ children, className = '' }) => {
  return (
    <div
      className={`p-4 border-t border-slate-100 bg-gradient-to-r from-slate-50 to-white ${className}`}
    >
      {children}
    </div>
  )
}